module.exports = __webpack_public_path__ + "static/media/file.b6687a36.svg";